"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use ShoppingBag from foundation/ShoppingBag
 * @trackcomponent
 */
export const BasketIcon = createSVGIcon(
  <>
    <path
      d="M3.39601 16.5001L0.631301 4.75012H22.3687L19.604 16.5001H3.39601Z"
      stroke="currentColor"
    />
    <path d="M7 10V1H16V10" stroke="currentColor" />
  </>,
  "Cart",
  { viewBox: "0 0 23 17", titleAccess: "Basket", fill: "none" }
);
